import React, { FC } from 'react';
import './App.scss';
import  { AuthProvider } from './hooks/useAuth';
import { LoadingProvider } from './hooks/useGlobalLoading';
import CustomBrowser from './routes/AppRoutes';



const App: FC = () => {
  document.title = 'All In One';

  return (
    <div className="App">
      <LoadingProvider>
        <AuthProvider>
          <CustomBrowser></CustomBrowser>
        </AuthProvider>
      </LoadingProvider>
    </div>
  );
};

export default App;
